import axiosPost from '../axiosPost';

export const estadosDeRegistroIns = async (arg) => {
    const { nombre, codigo } = arg;

    const body = {
        "service": "EstadoDeRegistroIns",
        "params": {
            "estadoDeRegistroNombre": nombre,
            "estadoDeRegistroCod": codigo
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
};